import { BillingMethodList } from '@/features/billing/components/BillingMethodList'
import { BillingMethodListItemContainer } from '@/features/billing/components/BillingMethodList/BillingMethodListItemContainer'
import { DeleteBillingMethodDialogContainer } from '@/features/billing/payment-methods/DeleteBillingMethodDialog/DeleteBillingMethodDialogContainer'
import { type PaymentMethodSelectorViewModel } from '@/features/billing/payment-methods/PaymentMethodSelectorViewModel'
import { ContentError } from '@/components/ContentError'
import { ContentLoading } from '@/components/ContentLoading'
import { useActivation } from '@/hooks/view-model-hooks'
import { observer } from 'mobx-react-lite'

export interface PaymentMethodSelectorContainerProps {
  vm: PaymentMethodSelectorViewModel
}

export const PaymentMethodSelectorContainer = observer(
  function PaymentMethodSelectorContainer({
    vm,
  }: PaymentMethodSelectorContainerProps) {
    useActivation(vm)
    return vm.fetch.match({
      pending: () => <ContentLoading size="compact" />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => (
        <>
          <BillingMethodList
            onAdd={vm.canManagePaymentMethods ? vm.newPaymentMethod : undefined}
            isAddDisabled={vm.selectMethod.pending}
          >
            {vm.methods.items.map((methodVm) => (
              <BillingMethodListItemContainer
                key={methodVm.id}
                vm={methodVm}
                onPress={methodVm.isSelected ? undefined : methodVm.select}
                onDelete={
                  vm.canManagePaymentMethods ? methodVm.delete : undefined
                }
                isDisabled={vm.selectMethod.pending}
              />
            ))}
          </BillingMethodList>
          <DeleteBillingMethodDialogContainer vm={vm.deleteDialogVm} />
        </>
      ),
    })
  },
)
